import Vue from 'vue'
import Vuex from 'vuex'
import { getStoreBuilder } from 'vuex-typex'
import { AuthState } from './auth/state'
import { CommentState } from './comment/state'
import { ConvoState } from './convo/state'
import { PostState } from './post/state'
import { StatementState } from './statement/state'
import { UserState } from './user/state'
import { MainState } from '@/store/main/state';

Vue.use(Vuex);

export interface RootState
{
  main: MainState
  auth: AuthState
  comment: CommentState
  convo: ConvoState
  post: PostState
  statement: StatementState
  user: UserState
}

export const buildStore =() => getStoreBuilder<RootState>().vuexStore()